var map = {
	"./DEMO/en.json": 52164,
	"./DEMO/fr.json": 63679,
	"./de.json": 95894,
	"./en.json": 44174,
	"./fr.json": 94605,
	"./it.json": 83672,
	"./nl.json": 34943,
	"./ro.json": 22354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89628;